CollectionWithHelpers = require 'models/collections/internal/collection-with-helpers'
Dates = require 'lib/dates'
Invitation = require 'models/invitation'

module.exports = class InvitationList extends CollectionWithHelpers
  model: Invitation

  initialize: (list, @options) ->

  comparator: (invitation) ->
    if invitation.get('dateExpires')
      -(Dates.parse(invitation.get('dateExpires')))
    else
      -Infinity



// WEBPACK FOOTER //
// ./app/scripts/models/collections/invitation-list.coffee